import styled from 'astroturf/react'
import _Time from "styles-Time.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/invitee_event/styles.js?styleId=Time";
import _Name from "styles-Name.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/invitee_event/styles.js?styleId=Name";
import _Wrapper from "styles-Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/invitee_event/styles.js?styleId=Wrapper";
import _RedesignConflictBadge from "styles-RedesignConflictBadge.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/invitee_event/styles.js?styleId=RedesignConflictBadge";
import _ConflictMarker from "styles-ConflictMarker.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/invitee_event/styles.js?styleId=ConflictMarker";

const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'
const greyLevel5 = 'var(--color-grey-3, #CCCCCC)'
const colorBgGrey2 = 'var(--color-bg-grey-2, #FAFAFA)'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'

export const Time = /*#__PURE__*/styled('div', null, {
  displayName: "Time",
  styles: _Time
})

export const Name = /*#__PURE__*/styled('div', null, {
  displayName: "Name",
  styles: _Name
})

export const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})

export const RedesignConflictBadge = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignConflictBadge",
  styles: _RedesignConflictBadge
})

export const ConflictMarker = /*#__PURE__*/styled('div', null, {
  displayName: "ConflictMarker",
  styles: _ConflictMarker
})
